<template>
  <div class="esterno">
    <div class="div_pre_puls" @click="scendi()">
      <div class="div_pulsante">
        <div class="cc1">
          <img
            alt="alla puntata"
            src="../../assets/spotify.png"
            class="imm_pulsante"
          />
        </div>
        <div class="cc2">
          <h5 class="pulsante_text">Ascolta!</h5>
        </div>
      </div>
    </div>

    <div>
      <img
        :alt="'puntata' + currentEp2.id"
        :src="require('../../assets/puntate/' + currentEp2.id + '.png')"
        class="cover"
      />
    </div>
    <br />
    <div class="overlay-titolo">
      <h2 class="titolo">{{ currentEp2.title }}</h2>
      <p v-if="currentEp2.FT != 'ND'" class="FT">FT. {{ currentEp2.FT }}</p>
    </div>
    <br />
    <div class="overlay-descrizione">
      <p class="descrizione" style="white-space: pre-line">{{ currentEp2.details }}</p>
    </div>
    <br />
    <!-- Puntata -->
    <div class="frame_puntata" id="frame_puntata">
      <iframe
        :src="totale(currentEp2.codice)"
        frameBorder="0"
        width="500"
        height="380"
        allowfullscreen=""
        allow="autoplay; clipboard-write; encrypted-media; 
            fullscreen; picture-in-picture"
        class="puntata"
      ></iframe>
    </div>
  </div>
</template>

<script>
export default {
    props: ['id'],
    data() {
        return {
        }
    },
    computed: {
        currentEp2: function () {
            return this.$store.state.db2[this.id];
        }
    },
    methods: {
        scendi() {
            document.getElementById("frame_puntata").scrollIntoView();
        },
        totale(_link) {
            let parte1 = 'https://open.spotify.com/embed/episode/';
            let parte2 = '?utm_source=generator&theme=0';
            return parte1 + _link + parte2;
        }
    },
}
</script>

<style>
.div_pre_puls {
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  margin-top: 1%;
  margin-bottom: 2%;
}
.div_pulsante {
  display: flex;
  justify-content: center;
  align-items: center;
  color: #2c3e50;
  box-shadow: rgba(0, 0, 0, 0.5) 0px 5px 5px;
  border-radius: calc(10px);
  background: #ccb7a4;
  width: 20%;
  margin-top: 0.3%;
}

.pulsante_text {
  font-weight: bolder;
  margin-left: 2%;
  margin-bottom:0;
  /* margin-right: 2%; */
}

.imm_pulsante {
  --max-height: 50px;
  /* Set a baseline width for your element */
  width: 95%;
  /* And limit it with our function above */
  max-width: calc(var(--max-height, 50px) * var(--img-ratio, 1));
}
.frame_puntata {
  display: flex;
  justify-content: center;
  align-items: center;
}
.overlay-titolo {
  color: #ffffff;
  box-shadow: rgba(0, 0, 0, 0.5) 0px 5px 5px;
  /* border: 2px solid #961313; */
  border-radius: calc(10px);
  background: #2c3e50;
  width: 80%;
  margin-left: 10%;
  padding: 1%;
}
.overlay-descrizione {
  color: #2c3e50;
  box-shadow: rgba(0, 0, 0, 0.5) 0px 5px 5px;
  /* border: 2px solid #961313; */
  border-radius: calc(10px);
  background: #ccb7a4;
  width: 80%;
  margin-left: 10%;
  padding: 1%;
}
.titolo {
  font-weight: bolder;
}
.FT {
  font-weight: bold;
}
.descrizione {
  margin-left: 2%;
  margin-right: 2%;
}
.cover {
  /* width:"400";
  height:"400"; */
  --max-height: 350px;
  /* Set a baseline width for your element */
  width: 70%;
  /* And limit it with our function above */
  max-width: calc(var(--max-height, 350px) * var(--img-ratio, 1));
  margin-top: 0.3%;
  box-shadow: rgba(0, 0, 0, 0.45) 0px 5px 15px;
}

.puntata {
  --max-height: 320px;
  /* Set a baseline width for your element */
  width: 85%;
  /* And limit it with our function above */
  max-width: calc(var(--max-height, 300px) * var(--img-ratio, 2));
}
@media screen and (max-width: 1000px) {
  .puntata {
    width: 95%;
    --max-height: 500px;
    max-width: calc(var(--max-height, 300px) * var(--img-ratio, 2));
  }
  .overlay-titolo {
    width: 90%;
    margin-left: 5%;
    margin-right: 5%;
  }
  .overlay-descrizione {
    width: 90%;
    margin-left: 5%;
    margin-right: 5%;
  }
  .div_pulsante {
    width: 40%;
  }

  .imm_pulsante {
    /* And limit it with our function above */
    max-width: calc(var(--max-height, 30px) * var(--img-ratio, 1));
  }
}
</style>